import { SegmentedControl, SegmentedControlProps } from "@mantine/core"
import classes from "./segmented-chip.module.css"

/** List tabs as a segmented control (one concept with de-network-admin): gray.2 tray, active segment white. Counts go inside the label. */
export function SegmentedTabs(props: Readonly<SegmentedControlProps>) {
  return (
    <SegmentedControl
      radius={10}
      {...props}
      classNames={{
        root: classes.segmentedRoot,
        indicator: classes.segmentedIndicator,
        control: classes.segmentedControl,
        label: classes.segmentedLabel,
        ...props.classNames,
      }}
    />
  )
}
